import { GlobalEvents } from 'Utils/constants';
import { GetBreakpointWidth } from 'Utils/globals-bp';
//import 'Utils/mere.js';
//import 'Modules/map-container';
//import { InitializeMapDestinations } from 'SrcJS/maps/mapbox-custom';

//import { hasMapDestinations, MapDestinationsElement } from 'SrcJS/maps/mapbox-custom--dependencies';
import { LazyInitializer } from 'Utils/LazyInitializer';

var hasLowCostCalendarDependencies = hasLowCostCalendar();
var PackageCalendarViewModel = undefined;
async function getComponent_LowCostCalendar() {
    await import('Utils/formatters');
    await import('SrcJS/knockout-extensions/knockout.spinner');
    await import('SrcJS/knockout-extensions/knockout.datepicker');

    const { PackageCalendarViewModel } = await import('KM/PackageCalendarViewModel');
    //console.log('>>> loaded: KM/PackageCalendarViewModel');
    return { PackageCalendarViewModel };
}

/*
// 1. getComponent
// 2. Initialize package view model
if (typeof InitializePackageViewModel == 'function') {
    InitializePackageViewModel();
}

// 3. Initialize package calendar model
if (document.getElementById("packageCalendar")) {
    searchViewModel.PackageCalendar().PageId(AppData.CurrentPageId);
    searchViewModel.PackageCalendar().HotelId(AppData.CurrentHotelId);
    searchViewModel.PackageCalendar().SearchPackageCalendar();
    searchViewModel.PackageCalendar().SubscribeSearching(); // <-- trigger Apploader
}
*/


AppLoader.loaded(async function () {
    //InitializePackageCalendar();
    if (hasLowCostCalendarDependencies) {
        InitScript_packagelogic();

        let init_lowCostCalendar = async function () {
            if (typeof PackageCalendarViewModel == "undefined") {
                PackageCalendarViewModel = (await getComponent_LowCostCalendar()).PackageCalendarViewModel;
            }
            InitializePackageCalendar();
            return true;
        }
        
        let lowCostCalendarElement = LowCostCalendarElement();
        let lazyInitializer = new LazyInitializer(lowCostCalendarElement, init_lowCostCalendar);
        lazyInitializer.init().then((result) => {
            //console.log('>>> lazyInitializer >> InitializePackageCalendar done', result);
        });
        //lazyInitializer.init();
    }
});




function LowCostCalendarElement() {
    return document.querySelector('#lowCostCalendar');
}

function hasLowCostCalendar() {
    let result =  (LowCostCalendarElement() != null);
    //console.log('>>> hasLowCostCalendar: ' + result);
    return result;
}

//function PackageCalendarElement() {
//    return document.querySelector('#packageCalendar');
//}

//function hasPackageCalendar() {
//    let result = (PackageCalendarElement() != null);
//    console.log('>>> hasPackageCalendar: ' + result);
//    return result;
//}


function InitializePackageCalendar() {
    let catched = false;
    let init_done = false;
    let init_PackageCalendar = function () {
        //console.log('>> GlobalEvents.SearchViewModel.Initialized: ', arguments);
        if (init_done) {
            return;
        } else {
            init_done = true;
        }


        if (typeof searchViewModel == "undefined" || !searchViewModel) {
            //console.log('>>> Nofound searchViewModel: ', searchViewModel);
            return;
        }

        // Initialize package view model
        if (typeof InitializePackageViewModel == 'function') {
            InitializePackageViewModel();
        }

        // 3. Initialize package calendar model
        if (document.getElementById("packageCalendar")) {
            if (searchViewModel.isMultipleResults()) {
                searchViewModel.PackageCalendar(new PackageCalendarViewModel(searchViewModel));
                searchViewModel.PackageCalendar().SectionVisible(false);
                searchViewModel.PackageCalendar().SectionFooter.Enabled(true);
                searchViewModel.PackageCalendar().SectionFooter.Visible(true);
                InitScript_PackageCalendarSettings();
                searchViewModel.PackageCalendar().DynamicSettings(true);
                searchViewModel.PackageCalendar().SendSettings(true);
                searchViewModel.PackageCalendar().PageId(searchViewModel.PageID());
                searchViewModel.PackageCalendar().SubscribeSearching();
                searchViewModel.PackageCalendar().SearchPackageCalendar();
                searchViewModel.PackageCalendar().RetrievingDataReady(true);
            } else /*if (searchViewModel.IsHotel() || searchViewModel.isSingleResults())*/ {
                searchViewModel.PackageCalendar(new PackageCalendarViewModel(searchViewModel));
                searchViewModel.PackageCalendar().SectionVisible(true);
                searchViewModel.PackageCalendar().SectionFooter.Enabled(false);
                searchViewModel.PackageCalendar().SectionFooter.Visible(false);
                InitScript_PackageCalendarSettings();
                InitScript_PackageCalendarData();
                searchViewModel.PackageCalendar().PageId(AppData.CurrentPageId);
                searchViewModel.PackageCalendar().HotelId(AppData.CurrentHotelId);
                searchViewModel.PackageCalendar().SubscribeSearching();
                searchViewModel.PackageCalendar().SearchPackageCalendar();
                searchViewModel.PackageCalendar().RetrievingDataReady(true);
            }

        }
    };

    
    if (searchViewModel) {
        if (searchViewModel.Initialized()) {
            init_PackageCalendar();
            catched = true;
        } else {
            let subscribe_handler = function (newValue) {
                if (!newValue) {
                    // try one more time later
                    searchViewModel.Initialized.subscribeOnce(subscribe_handler);
                    return;
                }

                init_PackageCalendar();
            };
            searchViewModel.Initialized.subscribeOnce(subscribe_handler);
        }
    }
    if (!catched) {
        AppLoader.on(GlobalEvents.SearchViewModel.Initialized, init_PackageCalendar);
    }
}

function InitScript_PackageCalendarSettings() {
    // moved from *.cshtml view

    if (!AppData)
        return;
    if (!AppData.PackageCalendarSettings)
        return;

    let defaultMode = null;
    if (typeof AppData.PackageCalendarSettings.DefaultMode != "undefined") {
        defaultMode = AppData.PackageCalendarSettings.DefaultMode;
    }
    if (typeof AppData.PackageCalendarSettings.ResponsiveDefaultModes != "undefined") {
        if (AppData.PackageCalendarSettings.ResponsiveDefaultModes) {
            let bpKey = '';
            let bpWidth = GetBreakpointWidth();
            if (bpWidth < 480) {
                // bp0 Mobile portrait  - Up to 479px
                bpKey = "bp0";
            } else if (bpWidth < 768) {
                // bp1 Mobile landscape - 480px to 767px
                bpKey = "bp1";
            } else if (bpWidth < 1024) {
                // bp2 Tablet portrait - 768px to 1023px
                bpKey = "bp2";
            } else if (bpWidth < 1280) {
                // bp3 Tablet landscape & small desktop - 1024px to 1279px
                bpKey = "bp3";
            } else {
                // bp4 Large desktop - 1280px and up
                bpKey = "bp4";
            }
            if (bpKey) {
                let bp_defaultMode = AppData.PackageCalendarSettings.ResponsiveDefaultModes[bpKey];
                if (bp_defaultMode && bp_defaultMode != '') {
                    defaultMode = bp_defaultMode;
                }
            }
        }

    }
    searchViewModel.PackageCalendar().SetDefaultMode(defaultMode);
    
}

function InitScript_PackageCalendarData() {
    // moved from *.cshtml view

    if (!AppData)
        return;
    if (!AppData.PackageCalendarData)
        return;

    if (typeof AppData.PackageCalendarData.AvailablePackageDays != "undefined") {
        searchViewModel.PackageCalendar().UpdateAvailablePackageDays(AppData.PackageCalendarData.AvailablePackageDays);
    }

    if (typeof AppData.PackageCalendarData.DefaultPackageDay != "undefined") {
        searchViewModel.PackageCalendar().DefaultPackageDay(AppData.PackageCalendarData.DefaultPackageDay);
        searchViewModel.PackageCalendar().SetDays(AppData.PackageCalendarData.DefaultPackageDay);
    }
}

function InitScript_packagelogic() {

    /* 2022-11-12 - show/hide has been moved into CSS on hover
    (function ($) {
        $.fn.packageMouseOver = function () {
            $('.package-day.hover').removeClass('hover');
            var $this = $(this);
            if ($this.hasClass('package-day')) {
                $this.addClass('hover');
            }
        }
        $.fn.packageMouseOut = function () {
            var $this = $(this);
            if ($this.hasClass('package-day')) {
                $this.removeClass('hover');
            }
        }
    })(jQuery);
    */

};
//AppLoader.loaded(InitScript_packagelogic);